<template>
    <modal id="embed-holidays" :show="openModal" :modalName="modalName">
        <template v-slot:header>
            <h2>Create Holiday Embed Now</h2>
        </template>
        <template v-slot:body>
            <div class="eh-wrapper">
                <div class="row settings">
                    <div class="selection-container">
                        <div class="selection-row">
                            <div class="selection-col">
                            <label class="text-uppercase small pl-1">EMBED TYPE</label>
                                <div class="button-group">
                                    <div class="button-with-info">
                                <div class="position-relative custom-input">
                                            <input type="radio" class="btn btn-primary" id="static" name="static" :checked="dataType === 'static'" @click="onChangeTypeEmbed('static')" @change="dataType = 'static'">
                                    <label for="static" class="static-data">
                                                <span class="icon-wrapper"><ListIcon /></span> <span>Static Data</span>
                                    </label>
                                </div>
                                        <div class="info-icon" @click="toggleHelp('static')">?</div>
                                        <div class="info-tooltip" v-if="activeHelpType === 'static'">
                                            Static Data: the embed is created and when people click they will send an email to you and you can carry on the booking manually with the customer via email.
                                        </div>
                                    </div>

                                    <div class="button-with-info">
                                <div class="position-relative custom-input">
                                            <input type="radio" class="btn btn-primary" id="live" name="live" :checked="dataType === 'live'" @click="onChangeTypeEmbed('live')" @change="dataType = 'live'">
                                    <label for="live" class="live-data">
                                                <span class="icon-wrapper">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-calendar-live">
                                                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                                        <line x1="16" y1="2" x2="16" y2="6"></line>
                                                        <line x1="8" y1="2" x2="8" y2="6"></line>
                                                        <line x1="3" y1="10" x2="21" y2="10"></line>
                                                        <circle cx="12" cy="15" r="2"></circle>
                                                    </svg>
                                                </span>
                                                <span>Live Booking</span>
                                    </label>
                                </div>
                                        <div class="info-icon" @click="toggleHelp('live')">?</div>
                                        <div class="info-tooltip" v-if="activeHelpType === 'live'">
                                            Live Booking: a live embed is created and the customer will pay their deposit and the confirmed booking will be sent to you. This adjusts the number of vacancies available on a set date trail.
                            </div>
                        </div>
                                    </div>
                                </div>

                            <div class="selection-col" v-if="dataType === 'live'">
                                <label class="text-uppercase small pl-1">CALENDAR TYPE</label>
                                <div class="button-group">
                                    <div class="button-with-info">
                                        <div class="position-relative custom-input">
                                            <input type="radio" class="btn btn-primary" id="setDates" name="setDates" :checked="!openCalendar" @click="onChangeOpenCalendar(false)" @change="openCalendar = false">
                                            <label for="setDates" class="static-data">
                                                <span class="icon-wrapper">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-calendar-set">
                                                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                                        <line x1="16" y1="2" x2="16" y2="6"></line>
                                                        <line x1="8" y1="2" x2="8" y2="6"></line>
                                                        <line x1="3" y1="10" x2="21" y2="10"></line>
                                                        <line x1="8" y1="14" x2="8" y2="14"></line>
                                                        <line x1="12" y1="14" x2="12" y2="14"></line>
                                                        <line x1="16" y1="14" x2="16" y2="14"></line>
                                                        <line x1="8" y1="18" x2="8" y2="18"></line>
                                                        <line x1="12" y1="18" x2="12" y2="18"></line>
                                                        <line x1="16" y1="18" x2="16" y2="18"></line>
                                                    </svg>
                                                </span>
                                                <span>Set Dates</span>
                                            </label>
                            </div>
                                        <div class="info-icon" @click="toggleHelp('setDates')">?</div>
                                        <div class="info-tooltip" v-if="activeHelpType === 'setDates'">
                                            Set Dates: This holiday has been created with set start dates and the available places will be automatically adjusted if a live booking is made.
                                        </div>
                                    </div>

                                    <div class="button-with-info">
                                        <div class="position-relative custom-input">
                                            <input type="radio" class="btn btn-primary" id="openCalendar" name="openCalendar" :checked="openCalendar" @click="onChangeOpenCalendar(true)" @change="openCalendar = true">
                                            <label for="openCalendar" class="live-data">
                                                <span class="icon-wrapper">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-calendar-open">
                                                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                                        <line x1="16" y1="2" x2="16" y2="6"></line>
                                                        <line x1="8" y1="2" x2="8" y2="6"></line>
                                                        <line x1="3" y1="10" x2="21" y2="10"></line>
                                                        <path d="M9 16H9.01"></path>
                                                        <path d="M15 16H15.01"></path>
                                                        <path d="M9 12H9.01"></path>
                                                        <path d="M15 12H15.01"></path>
                                                        <path d="M12 12H12.01"></path>
                                                        <path d="M12 16H12.01"></path>
                                                    </svg>
                                                </span>
                                                <span>Open Calendar</span>
                                            </label>
                                        </div>
                                        <div class="info-icon" @click="toggleHelp('openCalendar')">?</div>
                                        <div class="info-tooltip" v-if="activeHelpType === 'openCalendar'">
                                            Open Calendar: This holiday is available in a free date format so can start and finish on any days and dates as stipulated. Number of available places is not adjusted in this type of embed.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="text-center mt-4">
                            <button class="btn btn-primary create-embed-btn" @click="showConfigOptions = !showConfigOptions">
                                {{ showConfigOptions ? 'Hide Options' : 'Create Embed' }}
                            </button>
                        </div>

                        <div v-if="openCalendar" class="min-days-container" :class="{ 'hidden': !showConfigOptions }">
                            <label class="text-uppercase small">Min. Guests</label>
                                <b-form-input
                                style="-moz-appearance: textfield; width: 100px; height: 42px; font-size: 14px; text-align: center; border-radius: 6px; border: 1px solid #e0e0e0; margin-top: 5px;"
                                    type="number"
                                    class="hide-arrows"
                                    @input="event => this.changeValue(event)"
                                    :value="this.min_value">
                                </b-form-input>
                            <div class="min-days-info">
                                Set the minimum number of guests for the stay
                            </div>
                                </div>
                            </div>

                    <div v-if="showConfigOptions" class="config-container">
                        <div class="config-id" v-if="rowData?.instances?.[0]?.reference">
                            <div class="id-badge">
                                <span class="id-label">ID</span>
                                <span class="id-value">{{ rowData?.instances[0]?.reference }}</span>
                        </div>
                    </div>

                    <hr>
                    <div class="row row-settings">
                        <div class="col--5">
                            <div class="form-group">
                                <div class="lang-selector--wrapper">
                                    <label class="lang-selector--title text-uppercase small pl-1">
                                        Embed Language
                                    </label>
                                </div>
                                <div class="language-container">
                                    <select
                                        class="form-control lang-selector"
                                        @change="onSetLanguage"
                                        style="height: 42px;">
                                        <option
                                            v-for="option of langProps.options"
                                            :key="option.value"
                                            :value="option.value"
                                            v-bind:selected="option.value === langProps?.selected?.lang?.value">
                                                {{ option.label }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col--7">
                            <div class="form-group">
                                <div class="holy-title--wrapper">
                                    <label class="holy-title--title text-uppercase small pl-1">
                                        Holidays Title Override
                                    </label>
                                    <div class="save-wrapper" v-if="holidayTitle.changed">
                                        <i class="far fa-save" @click="onSaveTitle"></i>
                                    </div>
                                    <div
                                        class="save-wrapper saving-title"
                                        v-if="!holidayTitle.changed && savingTitle">
                                        Saving...
                                    </div>
                                </div>
                                <div class="title-container">
                                    <b-form-input
                                        v-model="holidayTitle.override"
                                        @keyup="onOverrideTitle"
                                        :disabled="langProps.selected.lang.value === 'en'"
                                        placeholder="Enter holiday name">
                                    </b-form-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                        <div class="row" style="height: auto; min-height: 75px">
                        <div class="original-price">
                            <label class="text-uppercase small pl-1" for="">original currency & price</label>
                            <div class="currency-container">
                                    <div v-for="item in this.getOriginalCurrency" :key="item.name" class="currency-wrapper original-currency-symbol" :id="item.code" @click="onChangeCurrency('')">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 35">
                                            <text
                                                id="_"
                                                data-name="£"
                                                font-size="18"
                                                font-weight="600"><tspan :x="item.symbol.length === 1 ? '13.893' : item.symbol.length === 2 ? '9' : '1'" y="24">{{ item.symbol }}</tspan></text>
                                        </svg>
                                </div>
                                <div class="currency-disp">{{ originalPrice.get() }}</div>
                            </div>
                        </div>
                        <span class="vertical-separator"></span>
                        <div class="embed-price">
                                <div class="col embed-currency">
                                <label class="text-uppercase small pl-1" for="">embed currency</label>
                                    <div class="currency-selector">
                                        <div class="currency-circles">
                                    <div v-if="this.default_currency === 'diff'">
                                        <div v-for="item in this.selectedCurrency" :key="item.name" class="currency-wrapper" :id="item.code" :class="activeCurrency === item.code ? 'active' : ''">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 35">
                                            <text
                                                id="_"
                                                data-name="£"
                                                font-size="18"
                                                font-weight="600"><tspan :x="item.symbol.length === 1 ? '13.893' : item.symbol.length === 2 ? '9' : '1'" y="24">{{ item.symbol }}</tspan></text>
                                        </svg>
                                    </div>
                                    </div>
                                    <div v-for="item in this.othersCurrency.slice(0, this.default_currency === 'default' ? 3 : 2)" :key="item.name" class="currency-wrapper" :id="item.code" @click="onChangeCurrency($event, 'default')" :class="this.default_currency === 'default' ? activeCurrency === item.code ? 'active' : '' : ''">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 35">
                                            <text
                                                id="_"
                                                data-name="£"
                                                font-size="18"
                                                font-weight="600"><tspan :x="item.symbol.length === 1 ? '13.893' : item.symbol.length === 2 ? '9' : '1'" y="24">{{ item.symbol }}</tspan></text>
                                        </svg>
                                    </div>
                                            <div v-if="this.currencies.length > 3" class="currency-wrapper curr_open_icon" @click="openDownModal">
                                      <svg v-bind:class="this.modalOpened ? 'icon_opened' : ''" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><path d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"/></svg>
                                    </div>
                                        </div>
                                        <div v-if="this.currencies.length > 3" v-bind:class="this.modalOpened ? 'curr_opened' : ''" class="currencies-modal">
                                        <div class="curr-padding">
                                            <div v-for="item in this.allDiffCurrencies" :key="item.name" class="currency-wrapper" :id="item.code" @click="onChangeCurrency($event ,item.code === 'EUR' || item.code === 'GBP' || item.code === 'USD' ? 'default' : 'diff')">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 35">
                                                <text
                                                    id="_"
                                                    data-name="£"
                                                    font-size="18"
                                                    font-weight="600"><tspan :x="item.symbol.length === 1 ? '13.893' : item.symbol.length === 2 ? '9' : '1'" y="24">{{ item.symbol }}</tspan></text>
                                            </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col embed-price-in">
                                <label class="text-uppercase small pl-1" for="">embed price</label>
                                    <div class="price-display">
                                        <div v-for="item in this.selectedCurrency" :key="item.name" class="currency-symbol">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 35">
                                            <text
                                                id="_"
                                                data-name="£"
                                                font-size="18"
                                                font-weight="600"><tspan :x="item.symbol.length === 1 ? '13.893' : item.symbol.length === 2 ? '9' : '1'" y="24">{{ item.symbol }}</tspan></text>
                                        </svg>
                                    </div>
                                        <div class="price-value">{{ embedPrice.get() }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                        <hr>
                        <div class="row row-settings">
                            <div class="col-12">
                                <div class="form-group">
                                    <div class="success-redirect--wrapper">
                                        <label class="text-uppercase small pl-1 success-redirect--title">
                                            Success Page Redirect (init http:// or https://)
                                        </label>
                                        <div class="save-wrapper" v-if="successPageRedirect.changed">
                                            <button class="btn-save-redirect" @click="onSaveSuccessRedirect">
                                                <i class="far fa-save"></i> Save
                                            </button>
                                        </div>
                                        <div class="save-wrapper saving-redirect" v-if="!successPageRedirect.changed && savingSuccessRedirect">
                                            Saving...
                                        </div>
                                    </div>
                                    <div class="redirect-container">
                                        <b-form-input
                                            v-model="successPageRedirect.value"
                                            @input="onSuccessRedirectInput"
                                            placeholder="Enter success page redirect URL">
                                        </b-form-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="row row-settings">
                            <div class="col-12">
                                <div class="form-group">
                                    <div class="success-redirect--wrapper">
                                        <label class="text-uppercase small pl-1 success-redirect--title">
                                            Booking Page Conditions (init http:// or https://)
                                        </label>
                                        <div class="save-wrapper" v-if="bookingConditions.changed">
                                            <button class="btn-save-redirect" @click="onSaveBookingConditions">
                                                <i class="far fa-save"></i> Save
                                            </button>
                                        </div>
                                        <div class="save-wrapper saving-redirect" v-if="!bookingConditions.changed && savingBookingConditions">
                                            Saving...
                                        </div>
                                    </div>
                                    <div class="redirect-container">
                                        <b-form-input
                                            v-model="bookingConditions.value"
                                            @input="onBookingConditionsInput"
                                            placeholder="Enter booking conditions URL">
                                        </b-form-input>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="embed-code-container">
                            <div class="code-header">
                                <h5>Embed Code</h5>
                                <button class="toggle-code-btn" @click="toggleEmbedCode">
                                    {{ showEmbedCode ? 'Hide Code' : 'Show Code' }}
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" :class="{'rotated': showEmbedCode}">
                                        <path fill="#6254ea" d="M8 12L2 6h12z"/>
                                    </svg>
                                </button>
                </div>
                            <div class="row embed-code" id="code-to-copy" :class="[codeCopied ? 'code-copied' : '', showEmbedCode ? 'visible' : 'hidden']">
                    <div v-if="!isLoadingToken">
                        &lt;div style="width:100%;" id="surefooted-embed-div" base_url="{{ baseUrl }}"
                        surefooted="{{ eToken }}"&gt;&lt;/div&gt;
                        &lt;script&gt;window.onload = function () { var surveyAppIndex = null; var scrpitIndex = null;
                        document.querySelectorAll('#surefooted-embed-div-script').forEach(s => { if (s.id ===
                        "surefooted-embed-div-script") { scrpitIndex = true; } }); if (scrpitIndex === null) { var script =
                        document.createElement("script"); script.id = "surefooted-embed-div-script"; script.src =
                        "{{ embedLink }}"; script.type = "text/javascript";
                        document.head.appendChild(script); }; var stylesheetIndex = null;
                        document.querySelectorAll('#surefooted-embed-div-stylesheet').forEach(s => { if (s.id ===
                        "surefooted-embed-div-stylesheet") { stylesheetIndex = true; } }); if (stylesheetIndex === null) { var link
                        = document.createElement("link"); link.id = "surefooted-embed-div-stylesheet"; link.rel = "stylesheet";
                        link.type = "text/css"; link.href =
                        "{{ embedCSS }}"; document.head.appendChild(link);
                        }; };&lt;/script&gt;
                    </div>
                    <div class="embed-loading" v-else>
                        Generating<span>...</span>
                    </div>
                </div>
                            <div class="embed-actions">
                                <button class="btn btn-cancel" @click="onCancel">Cancel</button>
                                <button class="btn btn-primary" @click="onCopyCode" :disabled="false">Copy Code</button>
                                <div v-if="codeCopied" class="copy-msm">{{ copyMsm }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <!-- Footer buttons moved to embed-actions -->
        </template>
    </modal>
</template>

<script>
import eventHub from '../utils/eventHub'
import ModalVue from './Modal.vue'
import { ref, computed, watch, reactive } from 'vue'
import Utils from '../utils/Utils'
import ListIcon from '../components/common/svg/ListIcon.vue'

export default {
    name: 'embed-holiday-modal',
    props: ['openModal', 'modalName', 'rowData', 'langs'],
    components: {
        modal: ModalVue,
        ListIcon
    },
    data () {
        return {
            token: null,
            embedLink: process.env.VUE_APP_EMBED_LINK,
            embedCSS: process.env.VUE_APP_EMBED_CSS,
            baseUrl: process.env.VUE_APP_API,
            amount: 0,
            rate: 1,
            codeToken: null,
            dataType: 'live',
            default_currency: 'default',
            originalCurrency: 'GBP',
            activeCurrency: null,
            codeCopied: false,
            copyDisabled: false,
            modalOpened: false,
            copyMsm: 'Code Copied!',
            isLoadingToken: false,
            savingTitle: false,
            openCalendar: false,
            url_condition: '',
            min_value: 1,
            selectedCurrency: [],
            othersCurrency: [],
            getOriginalCurrency: [],
            allDiffCurrencies: [],
            currencies: [],
            showConfigOptions: false,
            activeHelpType: null,
            showEmbedCode: false,
            successPageRedirect: {
                value: '',
                changed: false,
                originalValue: ''
            },
            bookingConditions: {
                value: '',
                changed: false,
                originalValue: ''
            },
            savingSuccessRedirect: false,
            savingBookingConditions: false
        }
    },
    created () {
        this.token = localStorage.getItem('accessToken')
        this.embedLink = process.env.VUE_APP_EMBED_LINK
        this.embedCSS = process.env.VUE_APP_EMBED_CSS
        this.baseUrl = process.env.VUE_APP_API
    },
    updated () {
        this.token = localStorage.getItem('accessToken')
        this.dataType = 'live'
    },
    setup (props) {
        const orignPrice = ref(0)
        const embPrice = ref(0)
        const convertedAmount = ref(0)
        const _userData = localStorage.getItem('userData')
        const userData = _userData ? JSON.parse(_userData) : null
        const userDesign = ref(_userData ? JSON.parse(_userData).design : null)
        const eToken = ref(null)
        const holidayTitle = reactive({
            original: props?.rowData?.holiday_name,
            override: null,
            setOverride: (value) => {
                holidayTitle.override = value
                holidayTitle.changed =
                    langProps.selected.lang.value !== 'en' &&
                    value !== holidayTitle.original
            },
            setLangTitle: (value) => {
                holidayTitle.override = value
            },
            changed: false,
            change: {
                value: false,
                get: () => {
                    return holidayTitle.changed
                },
                set: (value) => {
                    holidayTitle.changed = value
                }
            }
        })
        const langProps = reactive({
            options: computed(() => {
                if (props?.langs.length > 0) {
                    return [...props.langs]
                }
                return [
                    { value: 'en', label: 'English' },
                    { value: 'fr', label: 'Français _' }
                ]
            }),
            change: {
                value: false,
                get: () => {
                    return langProps.change.value
                },
                set: (value) => {
                    langProps.change.value = value
                }
            },
            selected: { //  default lang
                lang: { value: 'en', label: 'English' },
                get: () => {
                    return langProps?.selected?.lang?.value?.toUpperCase()
                },
                set: (event) => {
                    langProps.selected.lang = langProps.options.find(
                        lang => lang.value === event.target.value
                    )
                    langProps.change.set(true)
                }
            }
        })

        const originalPrice = computed(() => {
            return {
                get: () => {
                    return Number(orignPrice.value).toFixed(2)
                },
                set: (newValue) => {
                    orignPrice.value = Number(newValue).toFixed(2)
                }
            }
        })

        const embedPrice = computed(() => {
            return {
                get: () => {
                    return Number(embPrice.value).toFixed(2)
                },
                set: (newValue) => {
                    const roundedPrice = Math.ceil(newValue)
                    embPrice.value = Number(roundedPrice).toFixed(2)
                }
            }
        })

        const handleProps = (data) => {
            if (data?.holiday_name) {
                holidayTitle.override = data.holiday_name
                holidayTitle.original = data.holiday_name
            }
        }

        watch(() => props.rowData, handleProps)

        const convertion = computed(() => {
            return {
                get: () => {
                    return Number(convertedAmount.value).toFixed(2)
                },
                set: (newValue) => {
                    convertedAmount.value = Number(newValue).toFixed(2)
                }
            }
        })

        const embedToken = computed(() => {
            return {
                decode: (token) => {
                    return decodeURIComponent(escape(window.atob(token)))
                },
                encode: (data) => {
                    const rToken = window.btoa(unescape(encodeURIComponent(JSON.stringify(data))))
                    eToken.value = rToken
                }
            }
        })

        return {
            originalPrice,
            embedPrice,
            convertedAmount,
            convertion,
            embedToken,
            eToken,
            userDesign,
            userData,
            holidayTitle,
            langProps
        }
    },
    methods: {
      openDownModal () {
        this.modalOpened = !this.modalOpened
      },
      async requestCurrencyData (withLoading) {
      const companyId = this.loggedUser.id
      const payload = new FormData()

      payload.append('company_id', companyId)
      if (withLoading) {
        this.loader = this.$loading.show()
        this.isLoading = true
      }

      await this.axios
        .get(process.env.VUE_APP_API + '/aux/currencys')
        .then(result => {
          const { status } = result
          if ((status === 200 || status === 201) && result?.data.data) {
            this.currencies = result?.data?.data
          }
        })
        .catch(Utils.$handleHttpErrors)
        if (withLoading) {
          this.loader.hide()
          this.isLoading = false
        }
    },
        async requestEmbedToken () {
            this.isLoadingToken = true
            const companyId = this.rowData.company_id
            const holidayId = this.rowData.id
            const reqLang = this.langProps.selected.get()
            const data = new FormData()

            data.append('holiday_id', holidayId)
            data.append('language', reqLang)
            data.append('currency', this.activeCurrency)
            data.append('company_id', companyId)
            data.append('type_embed', this.dataType)
            data.append('min_value', this.min_value)
            data.append('open_calendar', this.openCalendar)
            data.append('success_page_redirect', this.successPageRedirect.value || '')
            data.append('booking_conditions', this.bookingConditions.value || '')

            const config = {
                method: 'post',
                url: process.env.VUE_APP_API + '/holiday/embedcode',
                data: data
            }
            await this.axios(config).then(respData => {
                if (respData?.status === 201) {
                    const parsedData = JSON.parse(respData?.data?.data)
                    this.rate = parsedData?.rate || 1
                    this.embedToken.encode({
                        token: parsedData?.token,
                        success_page_redirect: this.successPageRedirect.value,
                        booking_conditions: this.bookingConditions.value
                    })
                }
            }).catch(error => {
                console.error('API error:', error)
                Utils.$handleHttpErrors(error)
            })
            this.isLoadingToken = false
        },
        async requestHolidayData () {
            const holidayId = this.rowData.id
            const lang = this.langProps.selected.get()
            const data = new FormData()
            const config = {
                method: 'GET',
                url: process.env.VUE_APP_API + `/holiday/title/${holidayId}/${lang}`,
                data: data
            }
            await this.axios(config).then(respData => {
                if (respData?.status === 201) {
                    const holyTitle = this.holidayTitle.original
                    const langTitle = respData?.data?.title || holyTitle
                    this.holidayTitle.setLangTitle(langTitle)
                }
            }).catch(Utils.$handleHttpErrors)
        },
        async saveHolidayNewData () {
            const holidayId = this.rowData.id
            const newLang = this.langProps.selected.get()
            const newTitle = this.holidayTitle.override
            const data = new FormData()
            data.append('holiday_id', holidayId)
            data.append('language', newLang)
            data.append('title', newTitle)

            const config = {
                method: 'post',
                url: process.env.VUE_APP_API + '/holiday/title/save',
                data: data
            }
            await this.axios(config)
                    .then(respData => {})
                    .catch(Utils.$handleHttpErrors)
        },
        async fetchSuccessAndBookingData () {
            const companyId = this.rowData.company_id
            const holidayId = this.rowData.id
            const reqLang = this.langProps.selected.get()
            const data = new FormData()

            data.append('holiday_id', holidayId)
            data.append('language', reqLang)
            data.append('currency', this.activeCurrency)
            data.append('company_id', companyId)
            data.append('type_embed', this.dataType)
            data.append('min_value', this.min_value)
            data.append('open_calendar', this.openCalendar)

            const config = {
                method: 'POST',
                url: process.env.VUE_APP_API + '/holiday/embed-settings',
                data: data
            }

            try {
                const response = await this.axios(config)
                if (response?.status === 200 && response?.data) {
                    const successPageRedirectValue = response.data.success_page_redirect || ''
                    const bookingConditionsValue = response.data.booking_conditions || ''
                    this.successPageRedirect.value = successPageRedirectValue
                    this.successPageRedirect.originalValue = successPageRedirectValue
                    this.bookingConditions.value = bookingConditionsValue
                    this.bookingConditions.originalValue = bookingConditionsValue
                } else {
                    console.warn('Response status is not 200 or no data:', response)
                }
            } catch (error) {
                console.error('Error fetching embed settings:', error)
                console.error('Error details:', error.response)
                Utils.$handleHttpErrors(error)
            }
        },
        onCopyCode () {
            this.copyDisabled = true
            const elemCopy = document.getElementById('code-to-copy')

            const wasHidden = !this.showEmbedCode

            if (wasHidden) {
                elemCopy.classList.remove('hidden')
                elemCopy.classList.add('visible')
            }

            const range = document.createRange()
            range.selectNode(elemCopy)
            window.getSelection().removeAllRanges()
            window.getSelection().addRange(range)
            document.execCommand('copy')
            window.getSelection().removeAllRanges()

            if (wasHidden) {
                elemCopy.classList.remove('visible')
                elemCopy.classList.add('hidden')
            }

            this.codeCopied = true
            setTimeout(() => {
                this.codeCopied = false
                this.copyDisabled = false
            }, 2500)
        },
        async onSetLanguage (event) {
            this.langProps.selected.set(event)
            await this.requestHolidayData()
            // Fetch success and booking data for the new language
            await this.fetchSuccessAndBookingData()
            await this.requestEmbedToken()
        },
        async onOverrideTitle (event) {
            this.holidayTitle.setOverride(event.target.value)
        },
        async onSaveTitle (event) {
            this.holidayTitle.change.set(false)
            this.savingTitle = true
            await this.saveHolidayNewData()
            this.savingTitle = false
        },
        async onChangeCurrency (event, type) {
            this.default_currency = type
            this.activeCurrency = event.target.id

            this.selectedCurrency = this.currencies.filter(el => {
                return el.code === event.target.id
            })
            if (type === 'diff') {
            this.othersCurrency = this.currencies.filter(el => {
              if (this.activeCurrency === 'GBP') {
                return el.code === 'EUR' || el.code === 'USD'
              } else if (this.activeCurrency === 'EUR') {
                return el.code === 'GBP' || el.code === 'USD'
              } else if (this.activeCurrency === 'USD') {
                return el.code === 'GBP' || el.code === 'EUR'
              } else {
                return el.code === 'GBP' || el.code === 'EUR'
              }
            })

            this.allDiffCurrencies = this.currencies.filter(el => {
              if (el.code !== 'EUR' && el.code !== 'GBP') {
                return this.activeCurrency !== el.code
              }
            })
            } else {
                this.othersCurrency = this.currencies.filter(el => {
                    return el.code === 'GBP' || el.code === 'EUR' || el.code === 'USD'
                })
                this.allDiffCurrencies = this.currencies.filter(el => {
                if (el.code !== 'EUR' && el.code !== 'USD' && el.code !== 'GBP') {
                return this.activeCurrency !== el.code
              }
            })
            }
            this.modalOpened = false
            // Fetch success and booking data for the new currency
            await this.fetchSuccessAndBookingData()
            await this.requestEmbedToken()
        },
        async onChangeOpenCalendar (type) {
            this.openCalendar = type
            // Adding a small delay to ensure the state is updated
            setTimeout(() => {
                this.fetchSuccessAndBookingData()
                this.requestEmbedToken()
            }, 100)
        },
        async changeValue (event) {
            this.min_value = event
            await this.fetchSuccessAndBookingData()
            await this.requestEmbedToken()
        },
        async onChangeTypeEmbed (type) {
            this.dataType = type
            // Reset openCalendar when changing to Static Data
            if (type === 'static') {
                this.openCalendar = false
            }
            await this.fetchSuccessAndBookingData()
            await this.requestEmbedToken()
        },
        onCancel () {
            eventHub.$emit('embed-holidays-modal', false)
            eventHub.$emit('refresh-holidays', true)
        },
        async initVariables (values) {
            this.modalOpened = false
            this.openCalendar = false
            const { holiday_currency: holidayCurrency, instances, embed_code: embedCode, rate } = values
            this.amount = 0
            this.originalCurrency = holidayCurrency || 'GBP'
            this.getOriginalCurrency = this.currencies.filter(el => {
              return el.code === this.originalCurrency
            })
            this.activeCurrency = holidayCurrency || 'GBP'

            // Initialize success page redirect and booking conditions
            this.successPageRedirect.value = ''
            this.successPageRedirect.originalValue = ''
            this.successPageRedirect.changed = false
            this.bookingConditions.value = ''
            this.bookingConditions.originalValue = ''
            this.bookingConditions.changed = false

            // Fetch success page redirect and booking conditions from API
            await this.fetchSuccessAndBookingData()

            if (this.activeCurrency === 'GBP' || this.activeCurrency === 'USD' || this.activeCurrency === 'EUR') {
                this.default_currency = 'default'
            } else {
                this.default_currency = 'diff'
            }
            this.currencies.sort((a, b) => {
              return a.id - b.id
            })
            this.selectedCurrency = this.currencies.filter(el => {
              return el.code === this.activeCurrency
            })
            if (this.activeCurrency !== 'GBP' && this.activeCurrency !== 'USD' && this.activeCurrency !== 'EUR') {
                this.othersCurrency = this.currencies.filter(el => {
                if (this.activeCurrency === 'GBP') {
                    return el.code === 'EUR' || el.code === 'USD'
                } else if (this.activeCurrency === 'EUR') {
                    return el.code === 'GBP' || el.code === 'USD'
                } else if (this.activeCurrency === 'USD') {
                    return el.code === 'GBP' || el.code === 'EUR'
                } else {
                    return el.code === 'GBP' || el.code === 'EUR'
                }
                })
            } else {
                this.othersCurrency = this.currencies.filter(el => {
                    return el.code === 'GBP' || el.code === 'EUR' || el.code === 'USD'
                })
            }

            if (this.currencies.length > 3) {
              this.allDiffCurrencies = this.currencies.filter(el => {
              if (this.default_currency === 'diff') {
                return el.code !== this.originalCurrency && el.code !== 'EUR' && el.code !== 'GBP'
              } else {
                return el.code !== 'EUR' && el.code !== 'USD' && el.code !== 'GBP'
              }
            })
            }
            this.codeToken = embedCode || null
            this.originalPrice.set(instances[0].price)
            this.embedPrice.set(instances[0].price)
            this.rate = rate

            // Wait for fetchSuccessAndBookingData to complete before requesting embed token
            await this.fetchSuccessAndBookingData()
            await this.requestEmbedToken()

            this.embedToken.encode({
                token: this.codeToken
            })
        },
        toggleHelp (type) {
            this.activeHelpType = this.activeHelpType === type ? null : type
        },
        toggleEmbedCode () {
            this.showEmbedCode = !this.showEmbedCode
        },
        onSuccessRedirectInput (value) {
            // Mark as changed when user types
            this.successPageRedirect.changed = value !== this.successPageRedirect.originalValue
        },
        onBookingConditionsInput (value) {
            // Mark as changed when user types
            this.bookingConditions.changed = value !== this.bookingConditions.originalValue
        },
        async onSaveSuccessRedirect () {
            this.successPageRedirect.changed = false
            this.savingSuccessRedirect = true
            this.successPageRedirect.originalValue = this.successPageRedirect.value
            await this.requestEmbedToken()
            this.savingSuccessRedirect = false
        },
        async onSaveBookingConditions () {
            this.bookingConditions.changed = false
            this.savingBookingConditions = true
            this.bookingConditions.originalValue = this.bookingConditions.value
            await this.requestEmbedToken()
            this.savingBookingConditions = false
        }
    },
    watch: {
        rowData (newValue, oldValue) {
            if (newValue) {
                this.initVariables(newValue)
            }
        },
        openModal (newValue, oldValue) {
          const userData = localStorage.getItem('userData')
            if (userData) {
              const parsedData = JSON.parse(userData)
              this.url_condition = parsedData.url_condition
            }
            if (!newValue && oldValue) {
                // Modal is being closed, trigger refresh
                eventHub.$emit('refresh-holidays', true)
                this.codeToken = null
                this.isInit = false
                this.rate = 1
            }
        },
        rate (newRate, oldRate) {
            const price = Number(this.originalPrice.get())
            this.embedPrice.set(newRate * price)
        }
    },
    async mounted () {
      this.loggedUser = JSON.parse(localStorage.getItem('userData'))
      const { status } = this.loggedUser || {}
        if (status === 1 || status === '1') this.requestCurrencyData(true)
        await this.fetchSuccessAndBookingData()
         this.requestEmbedToken()
    },
    unmounted () {

    }
}
</script>

<style lang="scss">
    #embed-holidays {
        .modal__dialog {
            width: 42vw;
            max-width: 600px;
            padding: 30px 25px 0;

            @media (max-width: 1200px) {
                width: 42vw;
            }

            @media (max-width: 768px) {
                width: 85vw;
                padding: 20px 15px 0;
            }
        }

        .modal_body {
            margin-top: 5px;
        }

        .modal__footer .modal-footer {
            border: none;
            padding: 25px 0.75rem;
            display: flex;
            justify-content: flex-end;

            .btn {
                padding: 0.4rem 1.2rem;
                height: 45px;
                font-size: 15px;
                min-width: 100px;
                border-radius: 6px;
                transition: all 0.3s ease;
            }
            .btn-cancel {
                background-color: #ececec;
                margin-right: 10px;

                &:hover {
                    background-color: #e0e0e0;
                }
            }

            .btn-primary {
                box-shadow: 0 2px 6px rgba(98, 84, 234, 0.3);

                &:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 8px rgba(98, 84, 234, 0.4);
                }

                &:disabled {
                    opacity: 0.7;
                    transform: none;
                    box-shadow: none;
                }
            }
        }

        .eh-wrapper {
            width: 100%;

            *.row {
                margin-left: 0;
                margin-right: 0;

                @media (max-width: 576px) {
                    flex-direction: column;
                }
            }

            .settings {
                display: flex;
                flex-direction: column;
                border: 1px solid #d5d5d5;
                min-height: 200px;
                border-radius: 6px;
                padding: 16px 15px;
                margin-bottom: 25px;

                @media (max-width: 576px) {
                    padding: 12px 10px;
                    min-height: auto;
                }

                hr {
                    margin-top: 0.7rem;
                    margin-bottom: 0.7rem;
                }

                .row {
                    padding: 0 0 10px 0;
                }
            }
            .embed-code {
                position: relative;
                z-index: 2;
                background: #222222;
                border-radius: 6px;
                padding: 20px;
                color: #ffffff;
                font-size: 13px;
                line-height: 1.5;
                font-family: 'Courier New', monospace;
                border: 1px solid #333;
                transition: opacity 0.3s ease;
                word-break: break-all;

                &.show-code {
                    opacity: 1;
                    height: auto;
                    min-height: 100px;
                }

                &.hide-code {
                    opacity: 0;
                    height: 0;
                    padding: 0;
                    overflow: hidden;
                    border: none;
                    pointer-events: none;
                }
            }

            .embed-code.hidden {
                height: 0;
                opacity: 0;
                padding: 0;
                overflow: hidden;
                margin: 0;
                display: none;
            }

            .embed-code.visible {
                height: auto;
                opacity: 1;
                padding: 20px;
                margin-bottom: 15px;
                display: block;
                max-height: 200px;
                overflow: auto;

                @media (max-width: 576px) {
                    padding: 15px;
                    font-size: 12px;
                }
            }

            .icon-calendar-set, .icon-calendar-live, .icon-calendar-open {
                stroke: currentColor;
                }

                .custom-input > input[type=radio]:checked ~ label {
                .icon-calendar-set, .icon-calendar-live, .icon-calendar-open {
                    stroke: white;
                }
            }
        }
        .size-to--label {
            cursor: pointer;
            transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        }
        .size-to--label label {
            font-size: 0.8rem !important;
            cursor: pointer;
        }

        .selected_open {
            background-color: #614fe8 !important;
            color: white !important;
            border: 1px solid #3922e2 !important;
        }
        .not_selected {
            color: #614fe8 !important;
            border: 1px solid #3922e2 !important;
        }
        .selected_icon {
            fill: white !important;
        }
        .not_selected__icon {
            fill: #614fe8 !important;
        }

        .calendar-icon {
            font-size: 17px;
        }

        .copy-msm {
            position: absolute;
            bottom: -40px;
            right: 0;
            color: #49a649;
            background-color: rgba(255,255,255,0.9);
            padding: 5px 12px;
            border-radius: 4px;
            font-size: 14px;
            font-weight: bold;
            box-shadow: 0 1px 3px rgba(0,0,0,0.1);
            z-index: 10;
        }

        .currencies-modal {
            width: 220px;
            max-height: 0px;
            background-color: white;
            border-radius: 8px;
            overflow: hidden !important;
            position: absolute;
            top: 75px;
            left: 0;
            -webkit-transition: all 0.5s ease;
            -moz-transition: all 0.5s ease;
            -ms-transition: all 0.5s ease;
            -o-transition: all 0.5s ease;
            transition: all 0.5s ease;
            z-index: 10000;
            border: 1px solid #e0e0e0;
            opacity: 0;
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        }

        .curr-padding {
            padding: 15px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }

        .curr_open_icon {
            background-color: #efedfd;
                    display: flex;
                    align-items: center;
            justify-content: center;

            svg {
                width: 16px !important;
                height: 16px !important;
                fill: $primary !important;
            transition: all 0.5s ease;
            transform: rotate(0deg);
            }
        }

        .icon_opened {
            transform: rotate(-180deg) !important;
        }

        .curr_opened {
            opacity: 1;
            border: 1px solid #e0e0e0;
            max-height: 300px;
            transition: all 0.5s ease;
        }

        .code-copied {
            -webkit-box-shadow: 0px 0px 8px 0px #ADFF2F;
            box-shadow: 0px 0px 8px 0px #ADFF2F;
        }

        .selection-container {
            width: 100%;
            padding: 15px 0;
        }

        .selection-row {
                    display: flex;
            gap: 20px;
                    flex-wrap: wrap;

                        @media (max-width: 768px) {
                gap: 10px;
            }
        }

        .selection-col {
            flex: 1;
            min-width: 250px;

            @media (max-width: 576px) {
                min-width: 100%;
            }
        }

        .button-group {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 10px;
            margin-top: 10px;

            @media (max-width: 576px) {
                grid-template-columns: 1fr;
            }
        }

        .button-with-info {
                            display: flex;
            align-items: center;
            position: relative;
        }

        .info-icon {
                                display: flex;
            align-items: center;
            justify-content: center;
            width: 25px;
            height: 25px;
            border-radius: 50%;
            background-color: #6254ea;
            color: white;
            font-weight: bold;
            cursor: pointer;
            font-size: 16px;
            margin-left: 10px;
            box-shadow: 0 2px 4px rgba(0,0,0,0.2);
            transition: transform 0.2s ease;

            @media (max-width: 576px) {
                width: 22px;
                height: 22px;
                font-size: 14px;
                margin-left: 8px;
            }

            &:hover {
                transform: scale(1.1);
            }
        }

        .info-tooltip {
            position: absolute;
            top: 40px;
            left: 0;
            width: 250px;
            padding: 12px;
            background-color: #112640;
            color: white;
            border-radius: 4px;
            font-size: 13px;
            line-height: 1.5;
            box-shadow: 0 3px 10px rgba(0,0,0,0.2);
            z-index: 100;

            @media (max-width: 576px) {
                width: 220px;
                font-size: 12px;
                padding: 10px;
            }
        }

        .info-tooltip:after {
            content: "";
            position: absolute;
            bottom: 100%;
            left: 30px;
            border-bottom: 8px solid #112640;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
        }

        .custom-input {
            flex: 1;
            height: 45px;

            @media (max-width: 400px) {
                height: auto;
            }

            input[type=radio] {
                position: absolute;
                visibility: hidden;
            }

            label {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                width: 100%;
                height: 100%;
                border-radius: 6px;
                white-space: nowrap;
                background-color: #EFEDFD;
                color: #6254ea;
                cursor: pointer;
                        font-size: 14px;
                font-weight: 500;
                padding: 0 15px;
                transition: all 0.2s ease;

                @media (max-width: 400px) {
                    padding: 10px 15px;
                    white-space: normal;
                    min-height: 45px;
                }

                &:hover {
                    background-color: #e3e0f9;
                }

                .icon-wrapper {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 10px;
                    min-width: 22px;
                    width: 22px;
                    height: 22px;
                    flex-shrink: 0;
                }

                span {
                    transition: color 0.2s ease;
                }
            }
        }

        .custom-input > input[type=radio]:checked ~ label {
            background-color: $primary;
            box-shadow: 0 2px 8px rgba(98, 84, 234, 0.3);

            svg {fill: #ffffff;}
            span {color: #ffffff;}

            svg.live-data {
                fill: $primary !important;
                stroke: #ffffff;
            }
        }

        .create-embed-btn {
            padding: 10px 25px;
            min-width: 180px;
        }

        .min-days-container {
            margin-top: 15px;
            padding: 15px;
            background-color: #f9f8ff;
            border-radius: 6px;
            border: 1px solid #e0e0e0;
        }

        .min-days-info {
            font-size: 12px;
            color: #7E84A3;
            margin-top: 8px;
            font-style: italic;
        }

        .embed-code-container {
            margin-top: 25px;
            border-top: 1px solid #e0e0e0;
            padding-top: 20px;
        }

        .config-container {
            margin-top: 20px;
            border-top: 1px solid #e0e0e0;
            padding-top: 20px;
        }

        .config-id {
            display: flex;
            justify-content: flex-end;
            margin-bottom: 15px;

            .id-badge {
                    display: flex;
                    align-items: center;
                background-color: #f5f5f5;
                border-radius: 20px;
                padding: 4px 12px;
                font-size: 13px;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

                .id-label {
                    font-weight: bold;
                    color: #6254ea;
                    margin-right: 6px;
                }

                .id-value {
                    color: #333;
                    letter-spacing: 0.5px;
                }
            }
        }

        .hidden {
            display: none;
        }

        .original-currency-symbol {
            background-color: #f5f5f5;
            border: 1px solid #dedede;

            svg {
                fill: #555555;
            }
        }

        .currency-selector {
            position: relative;
                }

                .embed-price {
                    width: calc(60% - 1px);
            display: inline-flex;
            position: relative;

            @media (max-width: 576px) {
                width: 100%;
            }

                    .embed-currency {
                        display: flex;
                        flex-direction: column;
                width: 55%;
                padding-right: 15px;

                @media (max-width: 576px) {
                    width: 60%;
                }

                @media (max-width: 400px) {
                    width: 50%;
                        }
                    }

                    .embed-price-in {
                        display: flex;
                        flex-direction: column;
                        padding-right: 0;
                width: 45%;

                @media (max-width: 576px) {
                    width: 40%;
                }

                @media (max-width: 400px) {
                    width: 50%;
                }
            }
        }

        .currency-circles {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
            margin-bottom: 10px;

            @media (max-width: 400px) {
                gap: 8px;
                }
            }

            .currency-wrapper {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                display: flex;
                align-items: center;
            justify-content: center;
                cursor: pointer;
            margin: 0 4px 4px 0;
            transition: all 0.2s ease;
            background-color: #efedfd;

            @media (max-width: 400px) {
                width: 36px;
                height: 36px;
                margin: 0 3px 3px 0;
            }

            &:hover {
                transform: scale(1.05);
                box-shadow: 0 2px 4px rgba(0,0,0,0.1);
            }

            svg {
                width: 25px;
                height: 25px;
                fill: $primary;
                    pointer-events: none;

                @media (max-width: 400px) {
                    width: 22px;
                    height: 22px;
                }
            }
        }

        .price-display {
            display: flex;
            align-items: center;
            height: 42px;
            background-color: #f9f8ff;
            border-radius: 8px;
            border: 1px solid #e0e0e0;
            padding: 0 15px;
            box-shadow: 0 1px 3px rgba(0,0,0,0.05);

            @media (max-width: 400px) {
                padding: 0 10px;
            }
        }

        .currency-symbol {
            width: 24px;
            height: 24px;
                display: flex;
                align-items: center;
            justify-content: center;
            margin-right: 8px;

            @media (max-width: 400px) {
                width: 20px;
                height: 20px;
                margin-right: 5px;
            }

            svg {
                width: 24px;
                height: 24px;
                fill: #6254ea;

                @media (max-width: 400px) {
                    width: 20px;
                    height: 20px;
                }
            }
        }

        .price-value {
            font-size: 18px;
            font-weight: 600;
            color: #333;

            @media (max-width: 400px) {
                font-size: 16px;
            }
        }

        .code-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 12px;

            @media (max-width: 576px) {
                flex-direction: column;
                align-items: flex-start;
                gap: 8px;
            }

            h5 {
                margin: 0;
                font-size: 16px;
                font-weight: 600;
                color: #333;
            }
        }

        .toggle-code-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #f5f5f5;
            border: none;
            border-radius: 4px;
            padding: 6px 12px;
            font-size: 13px;
            color: #6254ea;
            cursor: pointer;
            transition: all 0.2s ease;

            @media (max-width: 576px) {
                width: 100%;
                justify-content: space-between;
            }

            &:hover {
                background-color: #e9e9e9;
            }

            svg {
                margin-left: 6px;
                transition: transform 0.3s ease;

                &.rotated {
                    transform: rotate(180deg);
                }
            }
        }

        .success-redirect--wrapper {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;

            .success-redirect--title {
                color: $secondary-gray;
                font-size: 12px !important;
                margin-bottom: 0;
            }

            .save-wrapper {
                display: flex;
                align-items: center;

                .btn-save-redirect {
                    background-color: $primary;
                    color: white;
                    padding: 5px 15px;
                    border-radius: 4px;
                    font-size: 13px;
                    border: none;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    display: flex;
                    align-items: center;
                    gap: 5px;

                    &:hover {
                        background-color: darken($primary, 10%);
                        transform: translateY(-1px);
                        box-shadow: 0 2px 4px rgba(98, 84, 234, 0.3);
                    }

                    i {
                        font-size: 12px;
                    }
                }

                &.saving-redirect {
                    color: $primary;
                    font-size: 13px;
                    font-style: italic;
                }
            }
        }

        .redirect-container {
            width: 100%;

            input {
                height: 42px;
                font-size: 14px;
                border-radius: 6px;
                border: 1px solid #e0e0e0;
                padding: 0 15px;
                transition: border-color 0.2s ease;

                &:focus {
                    border-color: $primary;
                    box-shadow: 0 0 0 0.2rem rgba(98, 84, 234, 0.15);
                }
            }
        }

        .embed-actions {
            display: flex;
            justify-content: flex-end;
            position: relative;
            margin-top: 45px;

            @media (max-width: 576px) {
                flex-direction: column;
                gap: 10px;
            }

            .btn {
                padding: 0.4rem 1.2rem;
                height: 45px;
                font-size: 15px;
                min-width: 100px;
                border-radius: 6px;
                transition: all 0.3s ease;

                @media (max-width: 576px) {
                    width: 100%;
                }
            }

            .btn-cancel {
                background-color: #ececec;
                margin-right: 10px;

                @media (max-width: 576px) {
                    margin-right: 0;
                    margin-bottom: 10px;
                }

                &:hover {
                    background-color: #e0e0e0;
                }
            }

            .btn-primary {
                box-shadow: 0 2px 6px rgba(98, 84, 234, 0.3);

                &:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 8px rgba(98, 84, 234, 0.4);
                }

                &:disabled {
                    opacity: 0.7;
                    transform: none;
                    box-shadow: none;
                }
            }
        }
    }
</style>
